exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-purple[data-v-c302e99e]:hover{color:grey!important}", ""]);

// exports
